import Table from "src/components/Common/UI/DndTable/Table";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import React from "react";
import { MisterIcon } from "@rtel/mister-icons";
import { Button } from "reactstrap";
import Modal from "src/components/Common/UI/Modal/Modal";
import CreatePhoneCenter from "./CreatePhoneCenter";
import EditPhoneCenter from "./EditPhoneCenter";
import DeletePhoneCenter from "./DeletePhoneCenter";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";
import { usePhoneCentersDataViewLogic } from "./hooks/usePhoneCentersDataViewLogic";


const PhoneCentersDataView = () => {

  const {
    data,
    columns,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    t,
    modalEvent
  } = usePhoneCentersDataViewLogic();

  const addPhoneCenterButton: React.FC = () => {
    return (
      <Button
        type="button"
        color="dark"
        onClick={ () => { actionEvent({action: "create"}); }}
        className="mb-1 d-none"
        size="sm"
        data-toggle="modal"
      >
        <MisterIcon name="Plus" size="sm" className="icon-light" /> {t(`Νέο Τηλεφωνικό Κέντρο`)}
      </Button>
    )
  };

  const ActionButtons: React.FC = () => (
    <TableActionButtons event={actionEvent} canEdit={selectedRowsOfTable.length > 0} canDelete={false} />
  );

  return (
    <>
        {loadingDone && (
          <>
            <Table
                columns={columns}
                data={data}
                defaultOrderByKeyFilter={"id"}
                showNumberOfRows={false}
                rowSelection={false}
                setRowSelection={setSelectedRowsOfTable}
                multipleRowSelection={false}
                actionRowId={"id"}
                debugMode={false}
                noDataFoundTitle="No PhoneCenters yet"
                isChangeOrderOrVisibilityEnable={false}
                ButtonsAreaLeft={ActionButtons}
                ButtonsAreaRight={addPhoneCenterButton}
                hiddenColumnsForUser={["deleted","filepath","hub_Type","anet_Voice","comments","physical_IF_ID","logical_IF_ID"]}
            />
          </>
        )}

        <Modal
          isOpen={!!modalEvent.action}
          closeFilterModal={closeActionModal}
          title={getModalTitleByAction()}  
          size="xl"
          >
            {modalEvent.action === "create" && <CreatePhoneCenter handleCloseModal={closeActionModal}/> }
            {modalEvent.action === "edit" && <EditPhoneCenter handleCloseModal={closeActionModal} PhoneCenterId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
            {modalEvent.action === "delete" && <DeletePhoneCenter handleCloseModal={closeActionModal} PhoneCenterId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
        </Modal>

        {!loadingDone && <LoadingSpinner />}
    </>
  )
}

export default PhoneCentersDataView;

